module.exports = __webpack_public_path__ + "static/austin-49366d9af1067b0d264148163f9ccaf6.png";